import { h, Component } from 'preact';
import HTML from 'components/core/html/html.js';
import s from 'components/bolt/airport/popUpWindows/stayConnected/stayConnected.sss';
import Store from 'store/store';

export default class StayConnected extends Component {

	constructor(props) {
		super(props);
		this.handleButtonClick = this.handleButtonClick.bind(this);
	}

	handleButtonClick(e, social) {
		e.stopPropagation();

		Store.emit('CUSTOM_EVENT', {
			category: 'stay-connected',
			action: 'social-icon-click',
			label: social.id
		});
		
		window.open(social.link, '_blank');
	}

	render({ section, imageRoot }) {
		const popUpCopy = section.popUp?.copy;

		return (
			<div class={s.container} onMouseDown={(e) => e.stopPropagation()} onTouchStart={(e) => e.stopPropagation()}>
				{(popUpCopy.subtitle || popUpCopy.description) && (
					<div class={s.content}>
						<HTML
							class={s.subtitle}
							markdown
							content={popUpCopy.subtitle}
						/>
						
						<HTML
							class={s.description}
							markdown
							content={popUpCopy.description}
						/>
						
					</div>
				)}
				<div class={s.socials}>
					{popUpCopy.socials.map(social => (
						social.link && (
							<button class={s.socialLink} key={`${social.id}-link`} onClick={(e) => this.handleButtonClick(e, social)}>
								<img src={`${imageRoot}/airport/socials/${social.id}.webp`} />
							</button> 
						)
					))}
				</div>
			</div>
		);
	}
}